import { memo } from "react";
import { StatusIndicatorPill } from "./StatusIndicatorPill";
import { CX } from "./MainArc";
import { PiSeatbelt, PiHandFist } from "react-icons/pi";
import { MdCarCrash } from "react-icons/md";
import { TbDoor } from "react-icons/tb";

const PILL_CY = 283;
const SPACING = 52;

// Static icon elements — created once at module load, never recreated
const ICONS = [
  <PiSeatbelt size={19} />,
  <MdCarCrash size={19} />,
  <TbDoor size={19} />,
  <PiHandFist size={19} />,
];

type Props = {
  seatbelt: boolean;
  airbag: boolean;
  doors: boolean;
  handbrake: boolean;
};

export const StatusIndicators = memo(function StatusIndicators({ seatbelt, airbag, doors, handbrake }: Props) {
  const states = [seatbelt, airbag, doors, handbrake];
  const totalWidth = (states.length - 1) * SPACING;
  const startX = CX - totalWidth / 2;

  return (
    <>
      {states.map((state, i) => (
        <StatusIndicatorPill
          key={i}
          cx={startX + i * SPACING}
          cy={PILL_CY}
          state={state}
          icon={ICONS[i]}
        />
      ))}
    </>
  );
});
